import Tooltip from './Tooltip.component';
export default Tooltip;